// Empty properties array - maintenance mode has been moved to API-based settings
// Keep this file for future experimentation features
export const properties: any[] = [];
